export function generateRandomId(): string {
  return '_' + (Math.random() * 0xffffff).toString()
}
